<template>
    <div>
        <!-- เมนูบน PC หรือ อุปกรณ์สื่อสารที่มีหน้าจอขนาดใหญ่ -->
        <v-app-bar app class="orange accent-3">
            <v-app-bar-nav-icon @click.native.stop="sideNav = !sideNav" class="hidden-md-and-up" dark></v-app-bar-nav-icon>
            <v-icon dark>mdi-bus</v-icon>
            <v-toolbar-title><font color="white">Delivery Kiosk</font></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-xs-only hidden-sm-only">
                <v-menu open-on-hover offset-y bottom v-for="item in menuItem" :key="item.title">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" dark router :to="item.link">
                            <v-icon>{{item.icon}}</v-icon>
                            {{item.title}}
                        </v-btn>
                    </template>
                    <v-list v-if="item.items">
                        <template v-for="subItem in item.items">
                            <v-list-item v-if="subItem.title == 'ออกจากระบบ'" :to="subItem.link" :key="subItem.title" 
                            color="orange accent-3" @click="logout">
                                <v-list-item-title>{{subItem.title}}</v-list-item-title>
                            </v-list-item>
                            <v-list-item color="orange accent-3" v-else :key="subItem.title" :to="subItem.link">
                                <v-list-item-title>{{subItem.title}}</v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-app-bar>

        <!-- เมนูบนมือถือ หรือ อุปกรณ์สื่อสารที่หน้าจอเล็ก -->
        <v-navigation-drawer temporary v-model="sideNav" dark absolute color="orange accent-3" style="position:fixed; top:0; left:0;">
            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-account-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{user}}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="white"></v-divider>

            <v-list dense nav>
                <v-list-item v-for="item in navItem" :key="item.title" router :to="item.link" color="white">
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider class="white"></v-divider>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title @click="logout">ออกจากระบบ</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-navigation-drawer>
        <br><br><br>
    </div>
</template>
<script>
export default {
    data(){
        return{
            sideNav: false,
            isAdmin: false,
            menuItem: [],
            navItem: [],
        }
    },
    methods:{
        menuRole(){
            this.menuItem = []
            this.navItem = []
            if(!sessionStorage.driver){
                this.$router.push('/login')
            }
            else{
                this.menuItem = [
                    { title: 'บันทึกเวลาจัดส่ง', icon: 'mdi-bus-clock', link: '/driver/timestamp' },
                    {title: this.user, icon: 'mdi-account-circle',
                        items:[
                            // { title: 'ผู้ใช้งานระบบ', link: '/Personal/psn' },
                            { title: 'ออกจากระบบ' },
                        ]
                    },
                ],
                this.navItem = [
                    { title: 'บันทึกเวลาจัดส่ง', icon: 'mdi-bus-clock', link: '/driver/timestamp' }
                ]
            }
        },
        logout(){
            sessionStorage.clear()
            this.$router.push('/login')
        }
    },
    computed:{
        user(){
            return sessionStorage.driver
        }
    },
    mounted(){
        this.menuRole()
    }
}
</script>
<style scoped>
.background{
  background-color: #FF9800;
}
.bgV-list{
  background-color: #FFE0B2;
}
.fontV-list{
  color: #FFCC80;
}
</style>